<template>
	<div class="report_container full">
		<el-container class="full">
			<el-header height="100">
				<div style="margin-top: 20px;">
					<el-row>
						<el-col :span="6">
							<div>
								<el-statistic group-separator="," :precision="2" :value="statistic.initialamount"
									title="上期期末余额"></el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic group-separator="," :precision="2" :value="statistic.payamount"
									title="本期支付金额"></el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic group-separator="," :precision="2" :value="statistic.needstockin"
									title="本期实际入库金额"></el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic group-separator="," :precision="2" :value="statistic.needpay"
									title="期末余额"></el-statistic>
							</div>
						</el-col>
<!-- 						<el-col :span="4">
							<div>
								<el-statistic group-separator="," :precision="2" :value="statistic.unpayamount"
									title="历史未结金额"></el-statistic>
							</div>
						</el-col> -->
					</el-row>
				</div>
			</el-header>
			<el-main>
				<vxe-form :data="formData" @submit="submitEvent">
					<vxe-form-item title="周期" field="date" :item-render="{}">
						<template #default="{ data }">
							<datePicker :shortcuts="[]" v-model="data.date" />
						</template>
					</vxe-form-item>
					<vxe-form-item title="供应商" field="suppliername" :item-render="{}">
						<template #default="{ data }">
							<vxe-input v-model="data.suppliername" placeholder=""></vxe-input>
						</template>
					</vxe-form-item>
					<vxe-form-item title="付款方式" field="paymentmethod" :item-render="{}">
						<template #default="{ data }">
							<el-select v-model="data.paymentmethod" placeholder="请选择" size="mini" clearable>
								<el-option label="月结" :value="8806">
								</el-option>
								<el-option label="现金" :value="8805">
								</el-option>
							</el-select>
						</template>
					</vxe-form-item>
					<vxe-form-item>
						<template #default>
							<vxe-button type="submit" status="primary">查询</vxe-button>
							<vxe-button @click="reset">重置</vxe-button>
						</template>
					</vxe-form-item>
				</vxe-form>
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="exportdata">导出</vxe-button>
					</template>
				</vxe-toolbar>

				<vxe-table border resizable show-footer ref="supplieraccountstable" height="650" align="center"
					:print-config="{}" :data="tableData" :loading="loading">
					<vxe-column type="seq" field="seq" title="序号" width="50"></vxe-column>
					<vxe-column field="supplierID" title="供应商ID" cellType="string"></vxe-column>
					<vxe-column field="supplierCode" title="供应商代码" cellType="string"></vxe-column>
					<vxe-column field="supplierName" title="供应商名称"></vxe-column>
					<vxe-column field="type_text" title="类别"></vxe-column>
					<vxe-column field="paymentmethod_text" title="付款方式"></vxe-column>
					<vxe-column field="paymentlevel_text" title="结算等级"></vxe-column>
					<vxe-column field="initialamount" title="上期末余额"></vxe-column>
					<vxe-column field="purchas_sum" title="本期订单额（采购订单总金额）"></vxe-column>
					<vxe-column field="purchasestockbill_sum" title="本期收货额（采购入库单总金额）"></vxe-column>
					<vxe-column field="purchaseoutstockbill_sum" title="调整数（退货订单总金额）"></vxe-column>
					<vxe-colgroup field="b" title="本期付款金额">
						<!-- 				<vxe-colgroup title="基本投入">
						<vxe-column field="f" title="人员经费"></vxe-column>
						<vxe-column field="g" title="公用经费"></vxe-column>
					</vxe-colgroup> -->
						<vxe-column field="amt" title="预付"></vxe-column>
						<vxe-column field="monthamt" title="月结"></vxe-column>
						<vxe-column field="receipt" title="票据"></vxe-column>
						<vxe-column field="discount" title="优惠"></vxe-column>
					</vxe-colgroup>
					<vxe-column field="needpay" title="期末余额"></vxe-column>
					<vxe-column field="jindieamount" title="星空余额"></vxe-column>
					<vxe-column field="diff" title="差额"></vxe-column>
					<!-- 			<vxe-colgroup field="b" title="期末余额">
					<vxe-column field="needpay" title="本期应付"></vxe-column>
					<vxe-column field="j" title="半月结"></vxe-column>
					<vxe-column field="j" title="月结"></vxe-column>
					<vxe-column field="j" title="季结"></vxe-column>
					<vxe-column field="j" title="小计"></vxe-column>
				</vxe-colgroup>		
				<vxe-column field="a" title="备注"></vxe-column>	 -->
				</vxe-table>
			</el-main>
		</el-container>

	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	export default {
		name: 'report',
		props: {

		},
		data() {
			return {
				loading: false,
				reportName: 'supplieraccounts',
				windowName: '供应商金额',
				tableData: [],
				formData: {
					paymentmethod: 8806,
					suppliername: null,
					date: [this.$Moment().startOf('day').valueOf(), this.$Moment().startOf('day').valueOf()],
				},
				statistic: {
					initialamount:0,
					needpay: 0,
					needstockin: 0,
					unpayamount: 0,
					payamount: 0
				}

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.list()

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.$api.supplieraccounts.list({
					date: this.formData.date.join(',') ? this.formData.date.join(',') : null,
					suppliername: this.formData.suppliername,
					paymentmethod: this.formData.paymentmethod
				}).then((res) => {
					this.tableData = res.list
					this.statistic = res.statistic
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			submitEvent() {
				this.list()
			},
			reset() {
				this.formData = {
					paymentmethod: 8806,
					suppliername: null,
					date: [this.$Moment().startOf('day').valueOf(), this.$Moment().startOf('day').valueOf()],
				}
				this.list()
			},
			exportdata() {
				this.$refs.supplieraccountstable.exportData({
					type: 'xlsx'
				})
			}
		},
		components: {
			datePicker
		}
	}
</script>